import { takeLatest, call, put } from "redux-saga/effects";
import { CITY_ADD_REQUEST } from "../../actions/cities";
import addCity from "../../../../../backend/oncall/partners/cities/add";
import { push } from "react-router-redux/actions";
import { cityAddError } from "../../actions/cities";

const requestAdd = function*(action) {
  try {
    const result = yield call(
      addCity,
      action.payload.formData.name,
      action.payload.formData.state,
      parseInt(action.payload.formData.regionId, 10),
      action.payload.formData.enabled,
    );
    yield put(push(`/city/edit/${result.id}`));
  } catch (error) {
    yield put(cityAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(CITY_ADD_REQUEST, requestAdd);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/cities/request-add.js